
import PropTypes from 'prop-types';

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { CountryDropdown } from 'react-country-region-selector';


import '../Components.css';
import './Shipping.css';

import { styles } from 'Utilities/Constants/Shipping_Constants';

var postalCodes = require('postal-codes-js');

class ShirtForm extends React.Component {

    handleChange = (field, value) => {
        let shippingValids = this.props.valids.shipping;
        switch (field) {
            case "country":
                if (value) {
                    shippingValids.country = true;
                } else {
                    shippingValids.country = false;
                }
                this.props.setCountry(value);

                //if country is valid, check if postal code (if entered already) is valid
                if (shippingValids.country) {
                    if (postalCodes.validate(value, this.props.postalCode) === true) {
                        shippingValids.postalCode = true;
                    } else {
                        shippingValids.postalCode = false;
                    }
                }
                break;

            case "provinceState":
                if (value !== undefined && value !== null && value !== "" && value.trim().length !== 0) {
                    shippingValids.provinceState = true;
                } else if (value === "") {
                    shippingValids.provinceState = false;
                }
                this.props.setProvinceState(value);
                break;

            case "city":
                if (value !== undefined && value !== null && value !== "" && value.trim().length !== 0) {
                    shippingValids.city = true;
                } else if (value === "") {
                    shippingValids.city = false;
                }
                this.props.setCity(value);
                break;

            case "address":
                if (value !== undefined && value !== null && value !== "" && value.trim().length !== 0) {
                    shippingValids.address = true;
                } else if (value === "") {
                    shippingValids.address = false;
                }
                this.props.setAddress(value);
                break;

            case "postalCode":
                if (value !== undefined && value !== null && value !== "" && value.trim().length !== 0) {
                    //now check if country has been filled, then we can confirm real postal code (by checking country is valid..)
                    if (this.props.valids.shipping.country) {
                        if (postalCodes.validate(this.props.country, value)) {
                            shippingValids.postalCode = true;
                        } else {
                            shippingValids.postalCode = false;
                        }
                    }
                } else if (value === "") {
                    shippingValids.postalCode = false;
                }
                this.props.setPostalCode(value);
                break;


            default:
                return;
        }

        //update valids
        let newValids = this.props.valids;
        newValids.shipping = shippingValids;
        this.props.updateValids(newValids);

    }

    processText = (field, value) => {
        this.handleChange(field, value);
    }



    render() {

        return (
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    <div className="section-header">Shipping Details</div>
                </Typography>
                <Grid container spacing={24} className={(!this.props.valids.shipping.country && this.props.nextAttempted)? "red-background" : ''}>
                    <Grid item xs={12} sm={6}>
                        <CountryDropdown
                            className="country-dropdown"
                            value={this.props.country}
                            // defaultValue={this.props.country}
                            valueType="short"
                            onChange={(value) => this.handleChange('country', value) } />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="province_state"
                            label="Province/State"
                            fullWidth
                            name="province_state"
                            onChange={e => this.processText('provinceState', e.target.value)}
                            value={this.props.provinceState}
                            // defaultValue={this.props.provinceState}
                            error={!this.props.valids.shipping.provinceState && this.props.nextAttempted}
                            helperText={(!this.props.valids.shipping.provinceState && this.props.nextAttempted) ? "Please enter the province/state" : ""}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="city"
                            name="city"
                            label="City"
                            fullWidth
                            onChange={e => this.processText('city', e.target.value)}
                            value={this.props.city}
                            // defaultValue={this.props.city}
                            error={!this.props.valids.shipping.city && this.props.nextAttempted}
                            helperText={(!this.props.valids.shipping.city && this.props.nextAttempted) ? "Please enter the city" : ""}
                        />

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="address"
                            name="address"
                            label="Address"
                            fullWidth
                            value={this.props.address}
                            // defaultValue={this.props.address}
                            onChange={e => this.processText('address', e.target.value)}
                            error={!this.props.valids.shipping.address && this.props.nextAttempted}
                            helperText={(!this.props.valids.shipping.address && this.props.nextAttempted) ? "Please enter the address" : ""}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="postalCode"
                            name="postalCode"
                            label="Postal Code"
                            fullWidth
                            value={this.props.postalCode}
                            // defaultValue={this.props.postalCode}
                            onChange={e => this.processText('postalCode', e.target.value)}
                            error={!this.props.valids.shipping.postalCode && this.props.nextAttempted}
                            helperText={(!this.props.valids.shipping.postalCode && this.props.nextAttempted) ? "Please enter the postal code" : ""}
                        />
                    </Grid>

                </Grid>

            </React.Fragment >
        )
    }
}

ShirtForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ShirtForm);